import './App.css';
import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

// Import theme
import { theme } from './utils/theme';

// Import data
import { teamData } from './data/contentData';
import { citationsData } from './data/publicationsData';

// Import components
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import SoftwareSolutionsSection from './components/SoftwareSolutionsSection';
import DataScienceSection from './components/DataScienceSection';
import TeamSection from './components/TeamSection';
import ResearchSection from './components/ResearchSection';
import ContactSection from './components/ContactSection';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Navigation />
      
      <Box id="hero-section">
        <HeroSection />
      </Box>

      <SoftwareSolutionsSection />

      <DataScienceSection />

      <TeamSection teamData={teamData} />

      <Box id="research-section" className="snap-section" sx={{ paddingTop: '64px' }}>
        <ResearchSection publications={citationsData} />
      </Box>
      
      <ContactSection />

      <Box 
        component="footer" 
        sx={{
          backgroundColor: theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800],
          padding: '24px',
          textAlign: 'center',
          borderTop: `1px solid ${theme.palette.divider}`
        }}
      >
        <Typography variant="body1" color="text.secondary">
          datasky limited
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {`© ${new Date().getFullYear()} Datasky. Company no: 768898. All Rights Reserved.`}
        </Typography>
      </Box>
      
    </ThemeProvider>
  );
}

export default App;
